// Installed before anything else so every schema this package exports — and
// every schema an app builds on top of them — reports in plain English rather
// than Zod's schema-author defaults. Import order matters: a `z.config` call
// applies to parses that happen after it, and re-exports below construct
// schemas at module load.
import { installHumanErrorMap } from "./validation/human-error-map";

installHumanErrorMap();

export * from "./validation/human-error-map";
export * from "./value-objects/index";
export * from "./currency/index";
export * from "./payments/index";
export * from "./billing/index";
export * from "./account-deletion/index";
export * from "./enums/review-platform";
export * from "./itinerary/resolve-inclusion-field";
export * from "./booking/seat-return";
export * from "./queues/cross-app-queue-names";
export * from "./email/jobs";
export * from "./booking/editability";
export * from "./booking/online-payment";
export * from "./booking/payment-received";
export * from "./booking/guest-details";
export * from "./booking/payment-reminder";
export * from "./booking/addon-lines";
export * from "./booking/charge";
export * from "./booking/expiry";
export * from "./booking/confirmed-statuses";
export * from "./booking/idempotency-key";
export * from "./booking/status-transitions";
export * from "./booking/seat-release-bucket";
export * from "./envelope/index";
export * from "./env/base-env";
export * from "./env/env-boolean";
export * from "./env/chargebee-fake-mode";
export * from "./env/r2-endpoint";
export * from "./env/local-defaults";
export * from "./http/request-keys";
export * from "./html/rich-html-vocabulary";
export * from "./html/legacy-plain-text";
export * from "./http/api-fetch";
export * from "./http/traveler-api-routes";
export * from "./cache/storefront-entities";
export * from "./storage/private-key-prefixes";
export * from "./storage/page-document-keys";
export * from "./cache/storefront-edge-tags";
export * from "./feature-flags/registry";
export * from "./feature-flags/rollout";
export * from "./feature-flags/resolve";
export * from "./dtos/index";
export * from "./video/video-source";
export * from "./media/image-variants";
export * from "./media/storage-layout";
export * from "./media/cdn-url";
export * from "./media/pexels-source-url";
export * from "./maps/map-embed";
export * from "./utils/storefront-origin";
export * from "./duration/duration-bands";
export * from "./duration/duration-label";
export * from "./availability/types";
export * from "./availability/compute-departures";
export * from "./availability/availability-window";
export * from "./availability/run-pattern";
export * from "./availability/cutoff-to-minutes";
export * from "./availability/run-period-date-matcher";
export * from "./availability/resolve-season-for-date";
export * from "./availability/departure-scarcity";
export * from "./clock/clock.port";
export * from "./clock/zoned-time";
export * from "./clock/timezones";
export * from "./clock/agency-today";
export * from "./id/id-generator.port";
export * from "./id/tour-thread-id";
export * from "./concurrency/uuid-to-advisory-lock-key";
export * from "./concurrency/pg-unique-violation";
export * from "./concurrency/concurrency-limiter";
export * from "./pricing/booking-math";
export * from "./pricing/charge-base";
export * from "./pricing/charge-base.schema";
export * from "./resources/resource-capacity";
export * from "./resources/hold-window";
export * from "./pricing/tier-unit-noun";
export * from "./pricing/tax-label";
export * from "./capacity/departure-capacity-for-date";
export * from "./capacity/resolve-departure-capacity";
export * from "./events/index";
export * from "./auth/booking-link-token";
export * from "./auth/checkout-ticket";
export * from "./auth/traveler-session-cookie";
export * from "./rbac/index";
export * from "./auth/recoverable-codes";
export * from "./auth/connector-codes";
export * from "./icons/travel-icons";
export * from "./icons/icon-keywords";
export * from "./apps/ads";
export * from "./apps/ads-storefront";
export * from "./apps/altitude-chart";
export * from "./apps/altitude-chart-geometry";
export * from "./apps/tour-brochure";
export * from "./apps/catalog";
export * from "./apps/translate-langs";
export * from "./apps/custom-scripts";
export * from "./apps/external-booking-link";
export * from "./apps/meta-catalog";
export * from "./apps/experience-add-ons";
export * from "./apps/mobile-quicknav";
export * from "./apps/posthog";
export * from "./apps/posthog-storefront";
export * from "./apps/posthog-journey";
export * from "./apps/redirections";
export * from "./apps/registry";
export * from "./apps/script-hosts";
export * from "./apps/search-console-verification";
export * from "./apps/whatsapp-widget";
export * from "./i18n/index";
export * from "./ai-form-engine/index";
export * from "./page-builder/reserved-paths";
export * from "./page-builder/page-document";
export * from "./page-builder/page-seo-text";
export * from "./page-builder/component-element";
export * from "./page-builder/video-block";
export * from "./page-builder/video-facade";
export * from "./page-builder/video-parts";
export * from "./page-builder/component-registry";
export * from "./page-builder/content-binding";
export * from "./page-builder/device-attrs";
export * from "./page-builder/tour-cards";
export * from "./page-builder/tour-card-template";
export * from "./page-builder/stored-card-template";
export * from "./page-builder/tour-carousel";
export * from "./page-builder/tour-accordion";
export * from "./page-builder/category-cards";
export * from "./page-builder/category-grid";
export * from "./page-builder/blog-posts";
export * from "./page-builder/reviews-block";
export * from "./page-builder/review-tabs";
export * from "./page-builder/tabs-initial-state";
export * from "./page-builder/search-options";
export * from "./page-builder/document-safety";
export * from "./page-builder/cms-path";
export * from "./page-builder/document-css";
export * from "./page-builder/css-layers";
export * from "./page-builder/preview-token";
export * from "./page-builder/template-hierarchy";
export * from "./page-builder/template-kind";
export * from "./page-builder/page-template";
export * from "./page-builder/template-slots";
export * from "./page-builder/built-in-page-templates";
export * from "./page-builder/template-body";
export * from "./page-builder/template-catalog";
export * from "./page-builder/parts";
export * from "./page-builder/template-capabilities";
export * from "./page-builder/builtin-patterns";
export * from "./page-builder/pattern-library";
export * from "./page-builder/pattern-images";
export * from "./page-builder/pattern-categories";
export * from "./page-builder/interactive-blocks";
export * from "./page-builder/carousel-classes";
export * from "./page-builder/carousel-settings";
export * from "./page-builder/custom-gap";
export * from "./page-builder/counter-settings";
export * from "./page-builder/accordion-settings";
export * from "./page-builder/dialog-settings";
export * from "./page-builder/lightbox-settings";
export * from "./page-builder/gallery-settings";
export * from "./page-builder/combobox-settings";
export * from "./page-builder/radio-group-settings";
export * from "./page-builder/departure-dates-block";
export * from "./page-builder/departure-dates-parts";
export * from "./page-builder/departure-dates-bind";
export * from "./page-builder/departure-dates-cards";
export * from "./page-builder/departure-dates-extras";
export * from "./page-builder/departure-dates-choices";
export * from "./page-builder/tour-search-settings";
export * from "./page-builder/copilot-agents";
export * from "./page-builder/copilot-attachments";
export * from "./page-builder/copilot-canvas-tools";
export * from "./page-builder/copilot-chat";
export * from "./page-builder/copilot-guides";
export * from "./page-builder/copilot-pattern-tools";
export * from "./page-builder/copilot-prompt-notes";
export * from "./page-builder/copilot-tool-registry";
export * from "./page-builder/copilot-tools";
export * from "./page-builder/resolve-templates";
export * from "./page-builder/template-ref-reach";
export * from "./menu/builtin-pages";
export * from "./menu/catalog-address";
export * from "./menu/menu";
export * from "./menu/menu-links";
export * from "./header-footer/elements";
export * from "./header-footer/layouts";
export * from "./header-footer/header-footer";
export * from "./header-footer/row-presets";
export * from "./header-footer/dom-ids";
export * from "./header-footer/social-marks";
export * from "./header-footer/payment-marks";
export * from "./header-footer/header-element-defaults";
export * from "./header-footer/footer-element-defaults";
export * from "./header-footer/seeds";
export * from "./tour-page";
export * from "./content-safety/css-syntax";
export * from "./content-safety/escape-html";
export * from "./content-safety/html-entities";
export * from "./content-safety/unsafe-css";
export * from "./content-safety/unsafe-html";
export * from "./content-safety/unsafe-url";
export * from "./reviews/platform-stats";
export * from "./phone/dial-country";
export * from "./checkout/answer-rules";
export * from "./checkout/booking-traveler-fields";
export * from "./checkout/customer-contact-answers";
